import React from "react";
import { useParams } from "react-router-dom";
import "./ProductGroup.css";
import Product from "../Product/Product.jsx";
import {
  getSelectorBuyplanItems
} from "components/Whiteboard/Helpers";

function ProductGroup(props) {

  const { month } = useParams();

  var buyPlanItems = getSelectorBuyplanItems();
  if ((!buyPlanItems || buyPlanItems.size == 0) && props.buyplanItems) {
  buyPlanItems = props.buyplanItems;
  }

  return (
  <div>
    {buyPlanItems && buyPlanItems.entrySeq().map(([formattedDate, buyplanItem]) => {
    var shortMonth = buyplanItem.get("short_month");
    if (shortMonth === month) {
      return (
      <div className="productGroup" data-month={formattedDate} key={shortMonth}>
        {buyplanItem.get("items").map((item) => {
        const itemId = item.get("id");
        return (
          <Product
          key={itemId}
          productimg={item.get("primary_image")}
          productname={item.get("name")}
          productsku={item.get("id")}
          productcolorcode={item.get("colour")}
          productwprice={item.get("wholesale_price")}
          productrprice={item.get("retail_price_formatted")}
          />
        );
        })}
      </div>
      );
    }
    })}
  </div>
  );
}

export default ProductGroup;
